import { ActionLogEntityType, CommanderThunkAction } from '@mews-commander/types';

interface LogActionLogInitProps {
    entityId: string;
    entityType: ActionLogEntityType;
    startTime: number;
}

export const logActionLogInit =
    ({ entityId, entityType, startTime }: LogActionLogInitProps): CommanderThunkAction =>
    (dispatch, getState, { loggerService }) =>
        loggerService.log('action-log-init', `${entityType} action log opened`, {
            entityId,
            entityType,
            time: window.performance.now() - startTime,
        });
